import { makeStyles } from "@fluentui/react-components";

export const useFormFieldStyles = makeStyles({
  textUpperCase: {
    textTransform: "uppercase",
  },
  inputFieldWrapper: {
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#F5F5F5",
  },
  inputFieldLabel: {
    fontSize: "10.24px",
    color: "#616161",
    lineHeight: "16.38px",
  },
  inputField: {
    padding: 0,
    border: "0px",
    backgroundColor: "transparent",
  },
});
